export default function VisaIntro() {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-blue-100">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              El Visado de Nómada Digital en España
            </h2>
            <p className="text-xl text-gray-700 leading-relaxed">
              España lanzó en 2022 el <strong>Visado de Nómada Digital</strong>, un permiso diseñado exclusivamente para trabajadores remotos que desempeñan su actividad para empresas extranjeras.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12 mb-12">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Este visado te permite:</h3>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                  <i className="ri-home-smile-fill text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">Vivir y trabajar legalmente</h4>
                  <p className="text-gray-600">Establece tu residencia legal en España mientras trabajas en remoto.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                  <i className="ri-calendar-check-fill text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">Hasta 3 años iniciales</h4>
                  <p className="text-gray-600">Renovables por 2 años más, con opción a residencia permanente.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                  <i className="ri-time-fill text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">Residencia de larga duración</h4>
                  <p className="text-gray-600">Acceso a la residencia permanente a los 5 años.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                  <i className="ri-sun-fill text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">Calidad de vida excepcional</h4>
                  <p className="text-gray-600">Clima, seguridad, cultura vibrante y alta calidad de vida.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl shadow-xl p-8 text-white text-center">
            <p className="text-2xl font-bold mb-4">
              España se ha convertido rápidamente en uno de los destinos predilectos para quienes desean combinar libertad profesional con estabilidad y bienestar.
            </p>
            <div className="flex flex-wrap justify-center gap-4 mt-8">
              <a 
                href="#consulta" 
                className="bg-white text-blue-700 px-8 py-4 rounded-lg font-bold text-lg hover:bg-blue-50 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Solicitar Consulta
              </a>
              <a 
                href="#requisitos" 
                className="bg-blue-500 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-blue-400 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Ver Recomendaciones
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
